import { getToken } from '../../auth/authService.ts';
import config from '../../config.json';

const API_URL = config.apiUrl;

async function authHeaders(): Promise<Record<string, string>> {
  const token = await getToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
}

export async function listUsers(search = '') {
  const res = await fetch(`${API_URL}/users?search=${search}`, {
    headers: await authHeaders()
  });
  return res.json();
}

export async function getUser(id: string) {
  const res = await fetch(`${API_URL}/users/${id}`, {
    headers: await authHeaders()
  });
  return res.json();
}

export async function createUser(username: string, email: string, password: string, group?: string) {
  const res = await fetch(`${API_URL}/users`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ username, email, password, group })
  });
  return res.ok;
}

export async function updateUser(id: string, data: {
  username?: string;
  email?: string;
  password?: string;
  group?: string;
}) {
  const res = await fetch(`${API_URL}/users/${id}`, {
    method: 'PUT',
    headers: await authHeaders(),
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error(`Failed to update user: ${res.status}`);
  return true;
}

export async function deleteUser(id: string) {
  const res = await fetch(`${API_URL}/users/${id}`, {
    method: 'DELETE',
    headers: await authHeaders()
  });
  return res.ok;
}
